import { Button } from '@/components/ui/button'
import RenderIf from '@/components/ui/render-if'
import { Section } from '@/components/ui/section'
import { Separator } from '@/components/ui/separator'
import { Text } from '@/components/ui/text'
import { TooltipInfo } from '@/components/ui/tooltip-v2'
// import { TooltipInfo } from '@/components/ui/tooltip'
import { PATH_NAME } from '@/config/path'
import { useQueryAccountCommissionSummary } from '@/data/referral'
import { CommonPlayForWork } from '@/icons'
import { useOpenClaimModal, useReferralActions, useReferralWallet } from '@/store'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AvailableRewardTokenBalance } from './AvailableRewardTokenBalance'
import { RewardTokenBalance } from './RewardTokenBalance'

import { ClaimReward } from '../claim-reward'

const MIN_CLAIM_AMOUNT = 50
export const ReferralRewardSummary = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const referralWallet = useReferralWallet()
  const openClaimModal = useOpenClaimModal()
  const { setOpenClaimModal } = useReferralActions()

  const { data: accountCommissionSummary, isFetching } = useQueryAccountCommissionSummary({
    walletAddress: referralWallet?.address || '',
  })
  const isDisabledClaimAll = (accountCommissionSummary?.availableUsdValue || 0) < MIN_CLAIM_AMOUNT
  const isDisabledClaimHistory = (accountCommissionSummary?.totalCommissionUsd || 0) < MIN_CLAIM_AMOUNT
  return (
    <Section ring={false} className='space-y-5 w-full md:w-[284px] text-center md:text-left'>
      <div className='flex items-center gap-1'>
        <Text as='p'>{t('title.TOTAL_COMMISSION_EARNED')}</Text>
        <TooltipInfo content={t('tooltip.TOTAL_REWARDS')} iconClassName='icon' />
      </div>

      <RewardTokenBalance
        commissionSummary={accountCommissionSummary}
        isFetching={isFetching}
        totalValue={accountCommissionSummary?.totalCommissionUsd}
        availableValue={accountCommissionSummary?.availableUsdValue}
      />

      <Separator />
      <div className='flex items-center gap-2 justify-center md:justify-start'>
        <AvailableRewardTokenBalance commissionSummary={accountCommissionSummary} isFetching={isFetching} />
        <div className='flex items-center gap-1'>
          <Text color='white-48' as='p'>
            {t('title.AVAILABLE_TO_CLAIM')}
          </Text>
          <TooltipInfo content={t('tooltip.AVAILABLE_TO_CLAIM')} iconClassName='icon' />
        </div>
      </div>
      <div className='flex items-center gap-2 justify-center md:justify-start'>
        <Button
          className='w-full'
          disabled={isDisabledClaimAll}
          onClick={() => {
            if (isDisabledClaimAll) return
            setOpenClaimModal(true, accountCommissionSummary?.availableUsdValue || 0)
          }}
        >
          <CommonPlayForWork className='size-6' />
          {t('button.CLAIM_ALL')}
        </Button>
        <Button
          onClick={() => {
            if (isDisabledClaimHistory) return
            navigate(`${PATH_NAME.CLAIM_HISTORY}/${referralWallet?.address}`)
          }}
          variant='secondary'
          className='w-full'
          disabled={isDisabledClaimHistory}
        >
          {t('button.CLAIM_HISTORY')}
        </Button>
      </div>
      <RenderIf condition={openClaimModal}>
        <ClaimReward />
      </RenderIf>
    </Section>
  )
}
